import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && key);

// Single shared client. Null when env vars are absent so the app can
// gracefully fall back to demonstration data.
export const supabase = isSupabaseConfigured
  ? createClient(url, key, {
      auth: { persistSession: false },
    })
  : null;
